import React from 'react';
import styles from './AccountHeaderBackground.module.scss';
import Image from 'next/image';
import { ShowOnDesktopOnly, ShowOnMobileOnly } from '@/components/show-on/ShowOn';
import { getImageUrl } from '@/services/images.service';

interface IAccountHeaderBackground {
    children: React.ReactElement;
    desktopBackgroundPath: string;
    mobileBackgroundPath: string;
}

export const AccountHeaderBackground: React.FC<IAccountHeaderBackground> = ({
    children,
    desktopBackgroundPath,
    mobileBackgroundPath,
}) => (
    <div className={styles.headerBackground}>
        <ShowOnMobileOnly>
            <Image
                src={getImageUrl(mobileBackgroundPath)}
                fill={true}
                quality={80}
                alt={'my account page background'}
            />
        </ShowOnMobileOnly>
        <ShowOnDesktopOnly>
            <Image
                src={getImageUrl(desktopBackgroundPath)}
                alt={'my account page background'}
                fill={true}
                quality={80}
            />
        </ShowOnDesktopOnly>
        {children}
    </div>
);
